import { LocationConflation } from '@rapideditor/location-conflation';

const _loco = new LocationConflation();    // instance of a location-conflation resolver

export { _loco as locationManager };
